import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Opponent } from './opponent';


@JsonObject('OpponentSearchResults')
export class OpponentSearchResults extends SearchResults {
    @JsonProperty('results', [Opponent])
    results: Opponent[] = [];
}
